import * as BlockUiOriginal from 'react-block-ui';

const BlockUi: any = BlockUiOriginal.default;
export default BlockUi;
